import React from 'react';

import {refHeightsDefaults} from 'utils/refHeights';

export const GlobalLayoutRefsContext = React.createContext({
  globalNavRef: {current: null},
  headerRef: {current: null},
  utilityNavRef: {current: null},
  // eslint-disable-next-line
  setPageNavMobileHeight: () => {},
  ...refHeightsDefaults,
});
